export default function Community() {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-600 to-teal-600 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-white/10 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full translate-x-1/3 translate-y-1/3"></div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Nuestro compromiso con la comunidad
          </h2>
          <div className="w-24 h-1 bg-white mx-auto rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6 text-white">
            <p className="text-lg leading-relaxed">
              En PaisaNet creemos en el esfuerzo y el espíritu emprendedor de la comunidad latina. Nuestro objetivo es ayudar a más personas a iniciar sus negocios, formalizar su trabajo y aprovechar las oportunidades que existen en Estados Unidos.
            </p>
            <p className="text-lg leading-relaxed">
              Sabemos que empezar puede ser complicado cuando no conoces el sistema. Por eso estamos aquí para guiarte, ayudarte con los trámites y apoyarte en cada paso para que puedas crecer y construir un mejor futuro para tu familia.
            </p>
            <p className="text-xl font-semibold leading-relaxed">
              Cada negocio que ayudamos a crear es una nueva oportunidad para nuestra comunidad.
            </p>
          </div>

          <div className="relative">
            <div className="w-full h-96 rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/65d99b640d0ac6aae186b4dcacf19a82.jpg"
                alt="Comunidad Latina"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16">
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-white mb-2">500+</div>
            <div className="text-white/90">Empresas creadas</div>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-white mb-2">1000+</div>
            <div className="text-white/90">Trámites completados</div>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-white mb-2">98%</div>
            <div className="text-white/90">Clientes satisfechos</div>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-white mb-2">5+</div>
            <div className="text-white/90">Años de experiencia</div>
          </div>
        </div>
      </div>
    </section>
  );
}